export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_DETAIL_PRODUCT = "SET_DETAIL_PRODUCT";
export const SET_PRODUCTS_CLIENT = "SET_PRODUCTS_CLIENT";
export const SET_DIALOG_ACTIVE = "SET_DIALOG_ACTIVE";  
export const SET_PRODUCT_BY_MODE = "SET_PRODUCT_BY_MODE";
export const SET_LIST_COUNTRY = "SET_LIST_COUNTRY"